import './index.less'
import VisibleComponent from '../VisibleComponent'

const template = `
    <div></div>
`
const iconList = ["cta","close","muted","unmuted","info","play"];
/**
 * Button类
 * @constructor
 * @extends VisibleComponent
 * @param options 构造参数
 */
class Button extends VisibleComponent {
    constructor(options = {}) {
        super(options)
        this.template = template
        this.init(options)
    }

    init(options) {
        super.init(options)
        const {
            type,
            shape,
            text,
            size,
            long,
            disabled = false,
            icon,
            color,
            background,
            theme,
            buttonClassName,
            onClick = () => {
            },
        } = options
        // 白色皮肤，或者不传，默认白色按钮
        if(!theme || theme === 'white'){
            switch (type) {
                case "cta":
                    this.element.classList.add("mtg-btn-cta")
                    break;
                case "countdown":
                    this.element.classList.add("mtg-btn-countdown")
                    break;
                case "close":
                    this.element.classList.add("mtg-btn-close-white")
                    break;
                case "flatClose":
                    this.element.classList.add("mtg-btn-close-flat-white")
                    break;
                case "muted":
                    this.element.classList.add("mtg-btn-muted-white")
                    break;
                case "unmuted":
                    this.element.classList.add("mtg-btn-unmuted-white")
                    break;
                case "info":
                    this.element.classList.add("mtg-btn-info-white")
                    break;
                case "play":
                    this.element.classList.add("mtg-btn-play")
                    break;
                case "default":
                    this.element.classList.add("mtg-btn")
                    break;
                default:
                    this.element.classList.add("mtg-btn")
            }
        }else if(theme === 'black'){   //  黑色皮肤，黑色按钮
            switch (type) {
                case "cta":
                    this.element.classList.add("mtg-btn-cta")
                    this.element.classList.add("jumpUrl")
                    break;
                case "countdown":
                    this.element.classList.add("mtg-btn-countdown")
                    break;
                case "close":
                    this.element.classList.add("mtg-btn-close")
                    break;
                case "flatClose":
                    this.element.classList.add("mtg-btn-close-flat")
                    break;
                case "muted":
                    this.element.classList.add("mtg-btn-muted")
                    break;
                case "unmuted":
                    this.element.classList.add("mtg-btn-unmuted")
                    break;
                case "info":
                    this.element.classList.add("mtg-btn-info")
                    break;
                case "play":
                    this.element.classList.add("mtg-btn-play")
                    break;
                case "default":
                    this.element.classList.add("mtg-btn-white")
                    break;
                default:
                    this.element.classList.add("mtg-btn-white")
            }
        }
        switch (size) {
            case "1":
                this.element.classList.add("mtg-btn-size-1")
                break;
            case "2":
                this.element.classList.add("mtg-btn-size-2")
                break;
            case "3":
                this.element.classList.add("mtg-btn-size-3")
                break;
            case "4":
                this.element.classList.add("mtg-btn-size-4")
                break;
            case "5":
                this.element.classList.add("mtg-btn-size-5")
                break;
            default:
                if(type === "default"){
                    this.element.classList.add("mtg-btn-size-1")
                }
        }
        switch (long) {
            case "1":
                this.element.classList.add("mtg-btn-long-1")
                break;
            case "2":
                this.element.classList.add("mtg-btn-long-2")
                break;
            case "3":
                this.element.classList.add("mtg-btn-long-3")
                break;
            case "4":
                this.element.classList.add("mtg-btn-long-4")
                break;
            case "5":
                this.element.classList.add("mtg-btn-long-5")
                break;
            default:
                if(type === "default"){
                    this.element.classList.add("mtg-btn-long-2")
                }
        }
        if (icon) {
            // 创建icon图片
            this.imgElem = new Image();
            this.imgElem.src = icon;
            this.element.appendChild(this.imgElem);
        }
        this.textElem = document.createElement("span");
        this.textElem.style.display = 'none'
        this.element.appendChild(this.textElem)
        if (text) {
            this.setText(text)
        }
        // 下载按钮兜底文案
        if (!text && type === "cta") {
            this.setText("Install")
        }
        if (color) {
            this.element.style.color = color;
        }
        if (background) {
            this.element.style.backgroundColor = background;
        }
        if (shape === 'circle') {
            this.element.classList.add("mtg-btn-circle")
        }
        if (!disabled) {
            console.log("button组件可以点击")
            console.log(" this.element", this.element)
            this.element.addEventListener('click', (e)=>{
                console.log("button点击event",e)
                onClick.call(this, e)
            }, false)
        }
        buttonClassName && this.addClass(this.element, buttonClassName)
    }
    
    setText(text) {
        this.textElem.innerText = text
        this.textElem.style.display = 'inline-block'
    }
}

export default Button